/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.CustomFields {

    @Serenity.Decorators.registerClass()
    export class CustomfieldsGrid extends NoboxEntityGrid<CustomfieldsRow, any> {
        protected getColumnsKey() { return CustomfieldsColumns.columnsKey; }
        protected getDialogType() { return CustomfieldsDialog; }
        protected getIdProperty() { return CustomfieldsRow.idProperty; }
        protected getInsertPermission() { return CustomfieldsRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomfieldsRow.localTextPrefix; }
        protected getService() { return CustomfieldsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            buttons.splice(0, 1);
            return buttons;
        }
    }
}